<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col sm="6">
          <base-material-card>
            <template v-slot:heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <va-field source="description"></va-field>
              <va-field source="coordinateX" type="number"></va-field>
              <va-field source="coordinateY" type="number"></va-field>
              <va-field source="coordinateZ" type="number"></va-field>
              <va-field source="coordinateW" type="number"></va-field>
              <va-field source="maps_id" type="select"></va-field>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: ["title", "item"]
};
</script>
